import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { isDefaultTheme } from '../../utils/theming.js';

// @ts-nocheck
var CarouselContainer = styled.div.withConfig({
  displayName: "Carouselstyle__CarouselContainer",
  componentId: "sc-qv5fl6-0"
})(["position:relative;"]);
var Carousel = styled.div.withConfig({
  displayName: "Carouselstyle__Carousel",
  componentId: "sc-qv5fl6-1"
})(["--item-size:calc(", " - 0.25);--visible-items:calc(4 / var(--item-size));", " ", " --item-width:calc( ( 100% - var(--space-grid-gutter) * (var(--visible-items) - 1) ) / var(--visible-items) );display:grid;grid-auto-flow:column;grid-template-columns:var(--item-width);grid-auto-columns:var(--item-width);overflow-x:auto;overflow-y:hidden;grid-gap:var(--space-grid-gutter);scroll-snap-type:x mandatory;padding:var(--space-100);margin:calc(-1 * var(--space-100));", " scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0;height:0;display:none;}> *{scroll-snap-align:center;&:first-child{scroll-snap-align:start;scroll-margin-left:var(--space-grid-margin);", "}", "}"], function (_ref) {
  var $itemSizeMobile = _ref.$itemSizeMobile;
  return $itemSizeMobile;
}, mq.s(css(["--item-size:", ";--visible-items:calc(12 / var(--item-size));"], function (_ref2) {
  var $itemSizeTablet = _ref2.$itemSizeTablet;
  return $itemSizeTablet;
})), mq.m(css(["--item-size:", ";"], function (_ref3) {
  var $itemSize = _ref3.$itemSize;
  return $itemSize;
})), mq.sMax(css(["padding:var(--space-100) var(--space-grid-margin);margin:calc(-1 * var(--space-100)) 0;"])), mq.s(css(["scroll-margin-left:var(--space-100);"])), mq.s(css(["scroll-snap-align:start;scroll-margin-left:calc(var(--space-100));"])));
var ScrollIndicator = styled.div.withConfig({
  displayName: "Carouselstyle__ScrollIndicator",
  componentId: "sc-qv5fl6-2"
})(["display:flex;margin:var(--space-500) auto 0;width:75%;", ""], mq.s(css(["width:600px;margin:var(--space-700) auto 0;"])));
var Part = styled.button.withConfig({
  displayName: "Carouselstyle__Part",
  componentId: "sc-qv5fl6-3"
})(["position:relative;height:1px;flex:1;background-color:var(--color-grey-300);transition:background-color ease 0.3s;&::before{content:'';position:absolute;height:32px;left:0;top:-16px;width:100%;}", ""], function (_ref4) {
  var $active = _ref4.$active;
  return $active && css(["", " background-color:var(--color-cta-button-primary);"], isDefaultTheme(css(["height:3px;margin-top:-1px;"])));
});
var NavButton = styled.div.withConfig({
  displayName: "Carouselstyle__NavButton",
  componentId: "sc-qv5fl6-4"
})(["display:none;align-items:center;justify-content:center;background-color:var(--color-black);opacity:90%;min-height:32px;min-width:32px;cursor:pointer;border-radius:50%;position:absolute;left:calc(-1 * var(--space-500) - 32px);z-index:100;top:calc(50% + 16px - var(--space-700));color:var(--color-white);transition:opacity var(--transition);@media (max-width:1350px){left:-16px;}", " ", " &:hover{opacity:100%;}", " ", ""], function (_ref5) {
  var $tightNavPosition = _ref5.$tightNavPosition;
  return $tightNavPosition && css(["left:-16px;"]);
}, function (_ref6) {
  var $right = _ref6.$right,
    $tightNavPosition = _ref6.$tightNavPosition;
  return $right && css(["transform:rotate(180deg);left:unset;right:calc(-1 * var(--space-500) - 32px);", " @media (max-width:1350px){right:-16px;left:unset;}"], $tightNavPosition && css(["right:-16px;left:unset;"]));
}, mq.s(css(["display:flex;"])), function (_ref7) {
  var $disabled = _ref7.$disabled;
  return $disabled && css(["pointer-events:none;opacity:30%;&:hover{opacity:30%;}"]);
});

export { Carousel, CarouselContainer, NavButton, Part, ScrollIndicator };
//# sourceMappingURL=Carousel.style.js.map
